import pluck from 'ramda/src/pluck'
import contains from 'ramda/src/contains'
import map from 'ramda/src/map'
import pipe from 'ramda/src/pipe'
import __ from 'ramda/src/__'

import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'
import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

// do we have this data?
const { viewLiveAssignees } = apiStoreLenses

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrAssignees } = responseLenses

export default (state, props) => {
	const assigneesIds = pluck(
		'platformId', pathOrAssignees([1], getRecordSelector(state, props)),
	)
	const liveAssignees = viewLiveAssignees(state)
	if (assigneesIds && liveAssignees) {
		return map(pipe(Number, contains(__, liveAssignees)), assigneesIds)
	}
	return []
}
